(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('AssessmentFormController', AssessmentFormController);

  /* ngInject */
  function AssessmentFormController($stateParams, $window, Flash, assessmentFrequencies, assessmentService, sessionService, vendorService) {
    const vm = this;

    vm.assessment = {};
    vm.assessmentFrequencies = assessmentFrequencies;
    vm.finalize = finalize;
    vm.isNewAssessment = true;
    vm.questionnaire = {};
    vm.update = update;
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getQuestionnaire();
      getVendor();
    }

    function finalize() {
      vm.assessment.finalize = true;

      assessmentService(sessionService.getAuthToken()).update({ id: vm.vendorId }, vm.assessment, response => {
        vm.assessment = response;
        Flash.create('success', 'Assessment successfully finalized.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again later.');
      });
    }

    function getAssessment() {
      assessmentService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => {
        vm.assessment = response;

        if (!vm.assessment.assessment) {
          vm.assessment.assessment = {};
          vm.isNewAssessment = true;
        } else {
          vm.isNewAssessment = false;
        }

        vm.assessment.notes = vm.assessment.assessment.notes;
        vm.assessment.assessment_questions = {};
        vm.assessment.assessment_question_notes = {};

        angular.element('[data-toggle="popover"]').popover();

        vm.assessment.assessment.assessment_answers.forEach(answer => {
          let questionId = findQuestionId(answer.assessment_answer.assessment_choice_id);
          if (questionId != null) {
            vm.assessment.assessment_questions[questionId] = answer.assessment_answer.assessment_choice_id;
          }

          vm.assessment.assessment_question_notes[questionId] = answer.assessment_answer.notes;
        });
      });
    }

    function findQuestionId(assessmentAnswerId) {
      var questionId;

      vm.questionnaire.assessment_categories.forEach(category => {
        category.assessment_questions.forEach(question => {
          question.assessment_choices.forEach(choice => {
            if (choice.id === assessmentAnswerId) {
              questionId = question.id;
            }
          });
        });
      });

      return questionId;
    }

    function getQuestionnaire() {
      assessmentService(sessionService.getAuthToken()).questionnaire({ id: vm.vendorId }, response => {
        vm.questionnaire = response;
        getAssessment();
      });
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }

    function update() {
      if (vm.isNewAssessment) {
        assessmentService(sessionService.getAuthToken()).create({ vendor_id: vm.vendorId }, vm.assessment, response => {
          vm.assessment = response;
          vm.isNewAssessment = false;
          Flash.create('success', 'Assessment successfully created.');
        }, _ => {
          Flash.create('danger', 'An unexpected error occurred. Please try again later.');
        });
      } else {
        assessmentService(sessionService.getAuthToken()).update({ id: vm.vendorId }, vm.assessment, response => {
          vm.assessment = response;
          Flash.create('success', 'Assessment successfully updated.');
        }, _ => {
          Flash.create('danger', 'An unexpected error occurred. Please try again later.');
        });
      }
    }
  }
})();
